import { styled } from 'styled-components'
import { ArrivesBeforeHolidayBadge as _ArrivesBeforeHolidayBadge } from 'components/ArrivesBeforeHolidayBadge/ArrivesBeforeHolidayBadge.styles'
import { ReactComponent as EnvelopeSvg } from '../../icons/assets/Envelope.svg'

export const ShippingOptionContainer = styled.div`
  margin-bottom: 20px;
`

export const ArrivesBeforeHolidayBadge = styled(_ArrivesBeforeHolidayBadge)`
  margin-top: 6px;
  margin-left: 39px;
`

export const EmailIcon = styled(EnvelopeSvg)`
  width: 32px;
  height: 32px;
  margin-left: -7px;
`
export const TokushohoDisclaimer = styled.a`
  color: unset;
  font-size: 14px;
  margin: 8px auto 0;
`
